<template>
    <div class="illustration-container">
        <icon name="piggybank-rocket" alt="Start saving" extension="png" directory="illustrations" class="illustration" />
    </div>

    <h2 class="h1">{{ t('widget.dollar-cost-average.start-dca.title') }}</h2>
    <p class="text center">{{ t('widget.dollar-cost-average.start-dca.description') }}</p>
    <p class="small-print center">{{ t('widget.dollar-cost-average.start-dca.cancel-anytime') }}</p>
</template>

<script lang="ts" setup>
import { Icon } from '@btcdirect/components/icons';
import { useTranslations } from '@btcdirect/composables';

const { t } = useTranslations();
</script>

<style lang="scss" scoped>
@use '@@scss/flex';
@use '@@scss/fonts';

.illustration-container {
    @include flex.flex;
    @include flex.align(end, center);

    .illustration {
        align-self: flex-end;
        width: 13.5em;
    }
}

h2 {
    margin-bottom: 0.75rem;
}

.small-print {
    @include fonts.font(0.875em, 1.5rem);
    padding-top: 1rem;
}
</style>
